import React, { useState } from "react";
import "./form3.css";
import { useNavigate } from 'react-router-dom';

const Formta3 = ({formData,setFormData,setStep}) => {
  

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = "தேர்ந்தெடுக்கவும்";
      }  
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const HandleNext = (e) => {
    e.preventDefault();
    if (validate()) {
      navigate(setStep(4));
    }
  };

  const handleBack = () => {
      setStep(2)
  };

  return (
    <>
    <div className="form3-background">
      <div className="form3-section">
        <h2 className="form3-title">குடும்ப விவரங்கள்(3/7)</h2>
        <form>
          <div className="form3-grid">
            <div className="form3-group">
              <label>தந்தையின் பெயர்<span className='error fs-star'>*</span></label>
              <input type="text" name="fatherName" placeholder="தந்தையின் பெயரை உள்ளிடவும்" value={formData.fatherName} onChange={handleChange} />
              {errors.fatherName && <span className="error-text">{errors.fatherName}</span>}
            </div>
            <div className="form3-group">
              <label>தாயின் பெயர்<span className='error fs-star'>*</span></label>
              <input type="text" name="motherName" placeholder="தாயின் பெயரை உள்ளிடவும்" value={formData.motherName} onChange={handleChange} />
              {errors.motherName && <span className="error-text">{errors.motherName}</span>}
            </div>
            <div className="form3-group">
              <label>தந்தையின் வேலை விவரம்<span className='error fs-star'>*</span></label>
              <input type="text" name="fatherJob" placeholder="தந்தையின் வேலை விவரத்தை உள்ளிடவும்" value={formData.fatherJob} onChange={handleChange} />
              {errors.fatherJob && <span className="error-text">{errors.fatherJob}</span>}
            </div>
            <div className="form3-group">
              <label>தாயின் வேலை விவரம்<span className='error fs-star'>*</span></label>
              <input type="text" name="motherJob" placeholder="தாயின் வேலை விவரத்தை உள்ளிடவும்" value={formData.motherJob} onChange={handleChange} />
              {errors.motherJob && <span className="error-text">{errors.motherJob}</span>}
            </div>
            <div className="form3-group">
              <label>தந்தையின் சொந்த ஊர்<span className='error fs-star'>*</span></label>
              <input type="text" name="fatherNative" placeholder="தந்தையின் சொந்த ஊரை உள்ளிடவும்" value={formData.fatherNative} onChange={handleChange} />
              {errors.fatherNative && <span className="error-text">{errors.fatherNative}</span>}
            </div>
            <div className="form3-group">
              <label>தாயின் சொந்த ஊர்<span className='error fs-star'>*</span></label>
              <input type="text" name="motherNative" placeholder="தாயின் சொந்த ஊரை உள்ளிடவும்" value={formData.motherNative} onChange={handleChange} />
              {errors.motherNative && <span className="error-text">{errors.motherNative}</span>}
            </div>
            <div className="form3-group">
              <label>உடன்பிறந்தோர்<span className='error fs-star'>*</span></label>
              <input type="text" name="siblings"  placeholder="உடன்பிறந்தோரின் எண்ணிக்கையை உள்ளிடவும்" value={formData.siblings} onChange={handleChange} />
              {errors.siblings && <span className="error-text">{errors.siblings}</span>}
            </div>
            <div className="form3-group">
              <label>சொத்து விவரங்கள்<span className='error fs-star'>*</span></label>
              <input type="text" name="property" placeholder="சொத்து விவரங்களை உள்ளிடவும்" value={formData.property} onChange={handleChange} />
              {errors.property && <span className="error-text">{errors.property}</span>}
            </div>
            <div className="form3-group">
              <label>முகவரி<span className='error fs-star'>*</span></label>
              <input type="text" name="address" placeholder="முகவரியை உள்ளிடவும்" value={formData.address} onChange={handleChange} />
              {errors.address && <span className="error-text">{errors.address}</span>}
            </div>
            <div className="form3-group">
              <label>எதிர்பார்ப்பு<span className='error fs-star'>*</span></label>
              <input type="text" name="expectation"  placeholder="உங்கள் எதிர்பார்ப்பை உள்ளிடவும்" value={formData.expectation} onChange={handleChange} />
              {errors.expectation && <span className="error-text">{errors.expectation}</span>}
            </div>
          </div>

          <div className="form3-btn-group">
            <button type="button" className="back-btn-3" onClick={handleBack}>முன்செல்ல</button>
            <button type="button" className="submit-btn-3" onClick={HandleNext}>தொடர்க</button>
          </div>
        </form>
      </div>
    </div>
   </>
  );
};
 
export default Formta3;
